import React from 'react'
import { usePartner } from '@@partner:helpers/hooks/auth'

import { generatePath, Link } from 'react-router-dom'
import { ButtonGroup, Button } from 'rsuite'
import LegacyPlusIcon from '@rsuite/icons/legacy/Plus'
import LegacyListIcon from '@rsuite/icons/legacy/List'
import BannerTypesGrid from '@components/marketing/banners/type/BannerTypesGrid'

import {
  ROUTE_MARKETING_BANNER_TYPE_ADD,
  ROUTE_MARKETING_BANNERS
} from '@@partner:config/routes'

export default function BannerTypesPage () {
  const { brandSlug } = usePartner()

  return (
    <div className="BannerTypesPage">
      <BannerTypesGrid brandSlug={brandSlug} />
    </div>
  )
}
